import { useEffect, useState } from 'react';
// TODO: Explore how it could be tested in jest, for now e2e tests for Dialog and Table are covering it's functionality - blurbyte
const orientationMap = {
    horizontal: {
        dimension: 'offsetWidth',
        scroll: 'scrollLeft',
        scrollDimension: 'scrollWidth',
    },
    vertical: {
        dimension: 'offsetHeight',
        scroll: 'scrollTop',
        scrollDimension: 'scrollHeight',
    },
};
/**
 * Occasionally for better user experience there is a need to hint that container is scrollable. Container should have `overflow: auto` or `overflow: scroll` specified via CSS.
 *
 * Depending on `orientation` and based on scroll position, show shadows or gradient masks at the appropriate positions.
 *
 * @param wrapperRef Ref of scrollable wrapper element
 * @param orientation Whether to show hints to the left and right or top and bottom, either `horizontal` or `vertical`
 * @returns Object of boolean values with `showStartHint`, and `showEndHint` entries
 */
function useShowScrollHint(wrapperRef, orientation = 'horizontal') {
    const [showStartHint, setShowStartHint] = useState(false);
    const [showEndHint, setShowEndHint] = useState(false);
    useEffect(() => {
        const wrapper = wrapperRef.current;
        function handleShowHints() {
            if (wrapper != null) {
                setShowStartHint(wrapper[orientationMap[orientation].scroll] > 0);
                // Because of differences between browsers, bottom or right positions are close approximation
                // Leave some wiggle room to take into account differences in calculations
                setShowEndHint(Math.ceil(wrapper[orientationMap[orientation].scrollDimension] -
                    wrapper[orientationMap[orientation].scroll]) -
                    wrapper[orientationMap[orientation].dimension] >
                    2);
            }
        }
        handleShowHints();
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.addEventListener('scroll', handleShowHints);
        window.addEventListener('resize', handleShowHints);
        return () => {
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener('scroll', handleShowHints);
            window.removeEventListener('resize', handleShowHints);
        };
    }, [wrapperRef, orientation]);
    return { showEndHint, showStartHint };
}
export default useShowScrollHint;
